// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1_AQk","itemTitle":"ClientEmergencyInfo_itemTitle__2xmnq","itemText":"ClientEmergencyInfo_itemText__1YMdG"};